const baseUrls = {
  // 门店管理
  orderStore: "/api/order/orderStore",
  viewInventory: "/api/order/viewInventory",
  meituanGift: "/api/order/meituanGift",
  productPool: "/api/order/productPool",
  freightStoreSsw: "/api/order/freightStoreSsw",
  ordPlatformOrderDetail: "/api/order/ordPlatformOrderDetail",
  privacy: "/api/order/privacy",
  storeSms: "/api/order/sms",
  // 设备管理
  device: "/api/system/device",
  baseArea: "/api/system/baseArea",
  iot: "/api/system/iot",
  // 设置模块 - 账号管理 - 用户管理
  user: "/api/system/user",
  // 设置模块 - 账号管理 - 菜单管理
  menu: "/api/system/menu",
  // 设置模块 - 账号管理 - 角色管理
  role: "/api/system/role",
  // 设置模块 - 配送设置
  deliverySettings: "/api/order/deliverySettings",
  // 设置模块 - 通知设置
  // 设置模块 - 操作日志
  log: "/api/system/log",
  // 商铺模块 - 商铺管理
  shop: "/api/order/stoShop",
  ordPlatformOrderRefundPay: "/api/order/ordPlatformOrderRefundPay",
  orderPicking: "/api/order/picking",
  orderDetail: "/api/order/ordPlatformOrderDetail",
  orderShop: "/api/order/stoShop",
  // 拣货单
  ordPicking: "/api/order/ordPicking",
  returnPay: "/api/order/returnPay",
  // 订单模块 - 订单处理
  order: "/api/order/order",
  // 订单模块 - 取消记录
  refund: "/api/order/refund",
  // 订单模块 - 配送信息
  delivery: "/api/order/order/ordDelivery",
  // 订单模块 - 配送信息详情
  deliveryInfo: "/api/order/order/ordDeliveryInfo",
  // 订单模块 - 货品
  orderGoods: "/api/order/order/goods",
  // websocket连接
  ws: process.env.VUE_APP_WEBSOCKET_URL,
  // 呼叫中心
  call: "/api/call/call",
  callBase: "/api/call/sys/sysCall",
  callSetting: "/api/call/sys/sysCallSetting",
  callStatusReport: "/api/call/sys/sysCallStatusRecord",
  callCdrReport: "/api/call/sys/sysCallCdrReport",
  callAnswerLog: "/api/call/sys/sysAnswerCallLog",
  callRingLog: "/api/call/sys/sysCallRingLog",
  callEndLog: "/api/call/sys/sysCallEndLog",
  callBind: "/api/call/sys/sysCallBind",
  callDataCount: "/api/call/sys/callDataCount",
  // 文件上传
  file: "/api/file",
  third: "/api/order/third",
  mqdelivery: "/api/order/delivery",
  mqrefund: "/api/order/refund",
  mqorderIm: "/api/order/orderIm",
  remoteSync: "/api/order/remoteSync",
  orderSelf: "/api/order/orderSelf",
  remind: "/api/order/remind",
  configRecycle: "/api/order/configRecycle",
  viewProductPoolGoods: "/api/order/viewProductPoolGoods",
  deliverySsw: "/api/order/deliverySsw",
  deliveryKfw: "/api/order/deliveryKfw",
  deliveryZsq: "/api/order/deliveryZsq",
  deliveryMtpt: "/api/order/deliveryMtpt",
  ordDelivery: "/api/order/ordDelivery",
  deliveryQyOpen: "/api/order/deliveryQyOpen",
  platCustomer: "/api/order/platCustomer",
  topsOrder: "/api/order/topsOrder",
  platUser: "/api/order/platUser",
  websocket: "/api/websocket/call",
  logOrder: "/api/order/logOrder",
  xinzhi: "/api/order/xinzhi"
};

export default baseUrls;
